


















































import Vue from 'vue'
import { createComponent, computed, SetupContext } from '@vue/composition-api'
import { MessageBox, Message } from 'element-ui'
import { preTransferHandler, electronDownload, getDesktopUrl, copyToClipboard } from '../helpers/common'
import { batchDeleteFileOrDir, unzip, rename, getCode, fileDownloadUrl, checkBeforeDownload } from '@/service/public'
import { useStore } from '@/hooks/common'
import IsElectron from 'is-electron'
import { transferThreshold, FilePower } from '@/constant'
import { compressPrompt } from '@/hooks/rightContextMenu'
import { findIsManager } from '@/helpers/common'
import { isEmpty } from 'lodash'
interface IProps {
    position: {
        x: number
        y: number
    }
}

export default createComponent({
    props: {
        position: {
            type: Object,
            default: () => ({ x: 0, y: 0 }),
        },
    },
    setup(props: IProps, setupContext) {
        const store = useStore()
        const manageTopIds = computed(() => store.state.ManageTopIds)
        // 文件管理员
        const isAdmin = computed(() =>
            findIsManager(manageTopIds.value as string[], store.state.publicStore.tableRowData.id)
        )
        // 超级管理员
        const hasSuperAdmin = computed(() => store.state.hasSuperAdmin)
        // 文件审批权限
        const isApproval = computed(() => {
            return (
                store.state.publicStore.tableRowData.powers &&
                store.state.publicStore.tableRowData.powers.includes(FilePower['APPROVAL'])
            )
        })
        // 当前选中数据的权限
        const currentTableRowDataPermissions = computed(() => {
            return store.state.publicStore.tableRowData.powers || []
        })
        const currentTableRowData = computed(() => {
            return store.state.publicStore.tableRowData || {}
        })
        // 判断是否为压缩文件
        const isZip = computed(() => {
            const name = store.state.publicStore.tableRowData.name
            const reg = /.*\.(.*)$/
            if (!reg.exec(name)) {
                return true
            }
            const extName = reg.exec(name)![1].toLocaleLowerCase()
            return extName === 'zip'
        })
        const isDisabledMenu = computed(() => {
            return !(store.state.publicStore.tableRowData.name && store.state.publicStore.tableRowData.id)
        })
        const isDisabledOpen = computed(() => {
            return store.state.publicStore.tableRowData.isFile
            // if (isAdmin.value || isApproval.value) return false
            // return !currentTableRowDataPermissions.value.includes(FilePower['PREVIEW'])
        })
        const isDisabledDownloadMenu = computed(() => {
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['DOWNLOAD'])
        })
        const isDisabledRename = computed(() => {
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['RENAME'])
        })
        const isDisabledCompressMenu = computed(() => {
            // 根目录不可压缩、解压、复制
            if (currentTableRowData.value.level === 1 && !currentTableRowData.value.isFile) return true
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['UNZIP_COMPRESS'])
        })
        const isDisabledUnzipMenu = computed(() => {
            if (!isZip.value) return true
            // 根目录不可压缩、解压、复制
            if (currentTableRowData.value.level === 1 && !currentTableRowData.value.isFile) return true
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['UNZIP_COMPRESS'])
        })
        const isDisabledMoveOrCopy = computed(() => {
            // 根目录不可压缩、解压、复制
            if (currentTableRowData.value.level === 1 && !currentTableRowData.value.isFile) return true
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['MOVE_COPY'])
        })

        const isDisabledDeleteMenu = computed(() => {
            // 根目录只有超级管理员能删除
            if (currentTableRowData.value.level === 1 && !currentTableRowData.value.isFile) {
                if (hasSuperAdmin.value) {
                    return false
                } else {
                    return true
                }
            }
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['DELETE'])
        })
        const isDisabledCheckDetail = computed(() => {
            // 不可见则不可查看详情
            if (!isZip.value && store.state.publicStore.tableRowData.isFile) return true
            if (isAdmin.value) return false
            return !currentTableRowDataPermissions.value.includes(FilePower['PREVIEW'])
        })

        const handleSelect = ( key: string, keyPath: string) => {
            menuClickHandler(key, setupContext.root, setupContext)
        }

        return {
            handleSelect,
            isDisabledMenu,
            isDisabledOpen,
            isDisabledUnzipMenu,
            isDisabledCompressMenu,
            isDisabledDownloadMenu,
            isDisabledDeleteMenu,
            isDisabledMoveOrCopy,
            isDisabledRename,
            isDisabledCheckDetail,
            isAdmin,
            isApproval,
        }
    },
})

async function menuClickHandler(
    // type: "open" | "download" | "permission" | "unzip" | "delete" | "rename" | "copy" | "move",
    type: string,
    rootVue: Vue,
    setupContext: SetupContext
) {
    const id = rootVue.$store.state.publicStore.tableRowData.id
    const name = rootVue.$store.state.publicStore.tableRowData.name
    const $$router = rootVue.$router
    if (type === 'open') {
        const routePath = rootVue.$route.path
        const data = rootVue.$store.state.publicStore.tableRowData
        const toRoutePath = (routePath + '/' + data.name).replace(/\/\//g, '/')
        rootVue.$store.commit('publicStore/SET_CURRENT_DIR_ID', id)
        rootVue.$store.commit('publicStore/UPDATE_TABLE_DATA_CACHE')
        const isChangeRoute = await rootVue.$store.dispatch('publicStore/getTableData', {
            updataType: 'init',
        })
        // if (!isChangeRoute) {
        //   return;
        // }
        $$router.push({ path: toRoutePath, query: { id: data.id } })
    }
    if (type === 'download') {
        const downloadFn = async () => {
            const res = await checkBeforeDownload(id)
            if (res.code === 0 && res.data) {
                const link = document.createElement('a')
                const origin = location.origin
                const userId = rootVue.$store.state.publicStore.userId
                link.href = `${origin}/api/downloadAfterCheck?keyword=${res.data}&userId=${userId}`
                link.click()
            }
        }
        if (IsElectron()) {
            console.log('发送请求到客户端')
            // console.log(rootVue.$store.state.publicStore.tableRowData);
            const file = rootVue.$store.state.publicStore.tableRowData
            if (file.isFile) {
                electronDownload(file, $$router)
            } else {
                Message.error('客户端暂不支持文件夹直接下载，请先压缩再下载')
            }
        } else {
            const row = rootVue.$store.state.publicStore.tableRowData
            const params = JSON.stringify(row)
            const desktopUrl = getDesktopUrl(params)
            const isContinue = await preTransferHandler({
                files: row,
                threshold: transferThreshold,
                url: desktopUrl,
                transType: 'download',
            })
            if (isContinue) {
                downloadFn()
            }
        }
    }
    // if (type === 'permission') {
    //     rootVue.$store.commit('publicStore/SET_PERMISSION_DIALOG_STATUS', true)
    // }
    if (type === 'rename') {
        // 校验函数定义在外部，拿不到store里的值，所以定义在里面
        const currentData = rootVue.$store.state.publicStore.tableRowData
        const fileNameValidator = (value?: string) => {
            const isFile = currentData.isFile
            if (!value) {
                return '名称不能为空！'
            }
            //   const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/;
            // eslint-disable-next-line no-useless-escape
            const reg = /^[\(\)0-9a-zA-Z\u4e00-\u9fa5_（）-]+$/
            // 只判断文件夹
            if (!reg.test(value) && !isFile) {
                return '名称只能包含数字字母汉字、下划线横线和括号'
            }
            return true
        }
        try {
            const MessageBoxData = await MessageBox.prompt('请输入新名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: name,
                inputValidator: fileNameValidator,
                closeOnClickModal: false,
            })
            const newFileName = (MessageBoxData as any).value
            const originalName = currentData.name
            let isPostRename = true
            // 如果是文件，判断是否修改后缀名，如果修改了后缀名，给确认框
            if (currentData.isFile) {
                const reg = /.*\.(.*)$/
                const newFileExtName = reg.exec(newFileName) && reg.exec(newFileName)![1].toLocaleLowerCase()
                const originalFileExtName = reg.exec(originalName) && reg.exec(originalName)![1].toLocaleLowerCase()
                if (originalFileExtName !== newFileExtName) {
                    try {
                        await MessageBox.confirm('如果改变文件扩展名，可能会导致文件不可用。确实要更改吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                        })
                    } catch (error) {
                        isPostRename = false
                    }
                }
            }
            if (!isPostRename) {
                menuClickHandler('rename', rootVue, setupContext)
                return
            }
            const res = await rename({
                id,
                newFileName,
            })
            if (res.code === 0) {
                Message.success(res.desc || '成功')
                rootVue.$store.dispatch('publicStore/getTableData')
                rootVue.$store.commit('publicStore/SET_IS_OPERATE', true)
            } else {
                Message.error(res.desc || '失败')
            }
        } catch (error) {
            console.log(error)
        }
    }
    if (type === 'unzip') {
        const res = await unzip(id)
        if (res.code === 0) {
            Message.success(res.desc || '成功')
            rootVue.$store.dispatch('publicStore/getTableData')
            rootVue.$store.commit('publicStore/UPDATE_UNZIP_LIST')
        } else {
            Message.error(res.desc || '失败')
        }
    }
    if (type === 'compress') {
        const currentData = rootVue.$store.state.publicStore.tableRowData
        await compressPrompt([currentData], rootVue.$store)
    }
    if (type === 'delete') {
        const isFile = rootVue.$store.state.publicStore.tableRowData.isFile
        const msg = `确认删除${isFile ? '文件' : '文件夹'} “${name}”？${
            isFile ? '' : '（删除文件夹会删除该文件夹下所有内容，请谨慎操作！）'
        }`
        try {
            await MessageBox.confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
            const res = await batchDeleteFileOrDir([id])
            if (res.code === 0) {
                Message.success(res.desc || '成功')
                rootVue.$store.dispatch('publicStore/getTableData')
                rootVue.$store.commit('publicStore/SET_IS_OPERATE', true)
            } else {
                Message.error(res.desc || '失败')
            }
        } catch (error) {
            console.log(error)
        }
    }
    // todo rebuild function
    if (type === 'copy') {
        rootVue.$store.commit('publicStore/SET_COPYMOVE_BOX', type)
        rootVue.$store.commit('publicStore/SET_COPYMOVE_BOX_SHOW', true)
    }

    if (type === 'details') {
        rootVue.$store.commit('publicStore/UPDATE_ZIP_DETAILS_DIALOG')
    }
    if (type === 'checkPermission') {
        rootVue.$store.commit('publicStore/SET_IS_VIEW_PERMISSION', true)
    }
    if (type === 'grant') {
        rootVue.$store.commit('publicStore/SET_IS_GRANT_PERMISSION', true)
    }
    if (type === 'permissionCode') {
        const res = await getCode(id)
        if (res.code === 0) {
            MessageBox.confirm(
                `当前文件（夹）权限码为${res.data}，权限码为动态密码，有效期为1小时，请及时使用权限码进行操作`,
                '权限码',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '复制权限码',
                    closeOnClickModal: false,
                }
            ).catch(() => {
                //  复制权限码
                copyToClipboard(res.data || '')
            })
        }
    }
    if (type === 'fileDownloadUrl') {
        const res = await fileDownloadUrl(id)
        if (res.code === 0) {
            MessageBox.confirm(`链接：${res.data}`, '生成文件链接', {
                confirmButtonText: '复制链接',
                cancelButtonText: '取消',
                closeOnClickModal: false,
            })
                .then(() => {
                    copyToClipboard(res.data || '')
                })
                .catch(() => {
                    console.log('取消复制')
                })
        }
    }
}
